import React, { useEffect, useState } from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Images from '../Images';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function Vacscorecard() {

    const data = [
        { category: "Coin Supply", question: "Is the maximum coin supply known?", answer: "Yes", score: 1 },
        { category: "", question: "Is the total coin supply known?", answer: "Yes", score: 1 },
        { category: "", question: "Is the circulating coin supply the same as the total supply?", answer: "No", score: 0 },
        { category: "Use Case", question: "Does it solve any specific need of humanity?", answer: "Yes", score: 1 },
        { category: "", question: "Are there two or more unique use cases?", answer: "Yes", score: 1 },
        { category: "", question: "Is there or will there be a DeFi application within the next 12 months?", answer: "No", score: 0 },
        { category: "Market Value", question: "Is it listed in at least one of the top five high-volume exchanges?", answer: "No", score: 0 },
        { category: "", question: "Is Total Liquidity Supply up to 30% of Undiluted Market Capitalization?", answer: "No", score: 0 },
         {category: "", question: "Is the 24-hour trading volume upto  one million USD?", answer: "No", score: 0 },
         {category: "Application", question: "Is the White Paper available and  well documented?", answer: "Yes", score: 1 },
         {category: "", question: " Is it an Open-Source code?", answer: "Yes", score: 1 },
         {category: "", question: "Is the Project audited by a reputable  crypto auditor?", answer: "Yes", score: 1 },
         {category: " Project  Team", question: "Is the Project Team known?", answer: "Yes", score: 1 },
         {category: "", question: "Is the Project registered with a  government regulatory body?", answer: "Yes", score: 1 },
         {category: "", question: "Has ownership of the Project been  renounced?", answer: "No", score: 0 },
    ];
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <div>
            <div>
                <Header />
                <div className='inner_page position-relative '>
                    <img src={Images.elogo} className='elogo' alt="elogo" />
                    <img src={Images.smallround} className='smallround_footer' alt='round'/>
                    <Container className='mt-5 pb-5'>
                        <div className='vac_border position-relative rounded-3 py-5 px-3 px-sm-4'>
                        <img src={Images.a1logo} className='a1logo' alt='round'/>
                        <img src={Images.a2logo} className='a2logo' alt="elogo" />
                        <img src={Images.a2logo} className='a3logo' alt="elogo" />
                            <Row>
                                <Col xl={9} xxl={10} className='mx-auto position-relative'>
                                <img src={Images.smallround} className='bot_round' alt='round'/>
                                <img src={Images.smallround} className='top_round' alt='round'/>
                                    <div className='vac_border academy pt-4'>
                                        <h4 className='text-center pb-3 px-2 fw-600'>Here is the EdaFace Academy SOC Scorecard for EDA coin</h4>
                                        <Table bordered hover responsive className='mb-0'>
                                            <thead>
                                                <tr className='score_head'>
                                                    <th rowSpan={2}>Item</th>
                                                    <th rowSpan={2}>Scorecard Investigative Question</th>
                                                    <th colSpan={2}>Response</th>
                                                </tr>
                                                <tr>
                                                    <th>
                                                       <p className='mb-0 hno'>Answer</p> 
                                                       <p className='mb-0 s_txt'>yes/no</p>
                                                        </th>
                                                    <th>
                                                    <p className='mb-0 hno'>Score</p> 
                                                    <p className='mb-0 s_txt'>yes=1 no=0</p>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((row, index) => (
                                                    <tr key={index}>
                                                        <td className='text-center fw-600'>{row.category || ""}</td>
                                                        <td>{row.question}</td>
                                                        <td className='text-center'>{row.answer}</td>
                                                        <td className='text-center'>{row.score}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className='text-center fw-600 tblefinal_head'   colSpan={2}>Total Score</td>
                                                    <td></td>
                                                    <td className='text-center'>10</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>


                                    <div className='vac_border interpretation pt-4'>
                                        <h4 className='text-center pb-3'>SOC Interpretation of Score</h4>
                                        <Table bordered hover responsive className='mb-1'>
                                            <thead>
                                                <tr>
                                                    <th className='hno'>Investment Interpretation</th>
                                                    <th className='hno'>Total Score</th>
                                                </tr>
                                            </thead>
                                            <tbody>                                              
                                                <tr>
                                                    <td >Bad Investment</td>
                                                    <td >0 – 3 (0 to 20%)</td>
                                                </tr>
                                                <tr>
                                                    <td >Cautious Investment</td>
                                                    <td >4 – 6 (21 to 40%)</td>
                                                </tr>
                                                <tr>
                                                    <td >Good Investment</td>
                                                    <td >7 – 9 (41 to 60%)</td>
                                                </tr>
                                                <tr>
                                                    <td >Very Good Investment</td>
                                                    <td >10 – 12 (61 to 80%)</td>
                                                </tr>
                                                <tr>
                                                    <td >Awesome Investment</td>
                                                    <td >13 – 15 (81 to 100%)</td>
                                                </tr>
                                                <tr>
                                                    <td className='fw-600 tblefinal_head'>Final Decision</td>
                                                    <td >
                                                        Very Good Investment
                                                        
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>

                                    </div>
                                    <div className='text-end me-4 mt-3'>
                                   <Link to="/vac-system"><button type='button' className='themebtn themehoverbtn rounded-1 mt-1 py-2 px-3 fw-600'>Criteria for</button></Link>
                                    </div>


                                </Col>
                            </Row>
                        </div>

                    </Container>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Vacscorecard;